import { DialogComponent } from "./chunk-FJH3KWUM.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Drawer/Drawer.tsx
import React from "react";
import clsx from "clsx";
var DRAWER_CLASSNAME_MAP = {
  position: {
    left: "pd-drawer--left",
    right: "pd-drawer--right"
  }
};
var Drawer = _a => {
  var _b = _a,
    {
      isOpen,
      onClose,
      children,
      title,
      dismissLabel,
      position = "left",
      className
    } = _b,
    rest = __objRest(_b, ["isOpen", "onClose", "children", "title", "dismissLabel", "position", "className"]);
  return /* @__PURE__ */React.createElement(DialogComponent, __spreadValues({
    isOpen,
    onClose,
    className: clsx("pd-drawer", DRAWER_CLASSNAME_MAP.position[position], className)
  }, rest), /* @__PURE__ */React.createElement(DialogComponent.Backdrop, {
    className: "pd-drawer__backdrop"
  }), /* @__PURE__ */React.createElement(DialogComponent.Front, {
    className: "pd-drawer__front"
  }, /* @__PURE__ */React.createElement(DialogComponent.Panel, {
    transition: position === "left" ? "slide-from-left-full" : "slide-from-right-full",
    className: "pd-drawer__panel"
  }, title && dismissLabel && /* @__PURE__ */React.createElement(DialogComponent.Header, {
    title,
    variant: "primary",
    onClose,
    dismissLabel
  }), title ? /* @__PURE__ */React.createElement(DialogComponent.Content, null, children) : children)));
};
var Drawer_default = Drawer;
export { Drawer_default };